<template lang="pug" src="./html/RunningTechTeams.pug"></template>

<script>

  import Vue from 'vue'
  import ArticleItemBase from './ArticleItemBase'

  const RunningTechTeamsBody = () => import(/* webpackChunkName: "running-tech-teams" */ './RunningTechTeams-Body')

  Vue.component('RunningTechTeamsBody', RunningTechTeamsBody)

  export default {
    extends: ArticleItemBase,
    mounted () {
      this.setBody('RunningTechTeamsBody')
    }
  }
</script>

<style lang="sass" src="./style/ArticleItem.sass"></style>

<style scoped>
    .article-item {
        color: #FFFFFF;
        background-color: #ff19a3;
        padding-bottom: 0 !important;
    }
    .intro {
        background-color: #ff19a3;
        padding-top: 1.2em;
    }
</style>

<style>
    #app.running-technology-teams #top-header {
        background-color: #343338;
    }
    #app.running-technology-teams #load-anim {
        stroke: #ff19a3;
    }
</style>
